import React from 'react'
import update from 'immutability-helper'

import { browserHistory } from 'react-router'

class DatosAdmin extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: 'lista-datos-admin'
        }
    }

    rederigir(e) {
        e.preventDefault()

        let id = e.target.id

        if (id === 'lista-datos-admin') {
            browserHistory.push('/contacto')
        } else if (id === 'nuevo-dato-admin') {
            browserHistory.push('/contacto/nuevo-dato-admin')
        }

        this.setState(update(this.state, {
            tab: { $set: id }
        }))
    }

    render() {
        let childs = this.props.children
            && React.cloneElement(this.props.children)

        return (
            <div className='config'>
                <ul className='nav justify-content-center'>
                    <li id='lista-datos-admin' className={this.state.tab === 'lista-datos-admin' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='lista-datos-admin' className='nav-link' onClick={this.rederigir.bind(this)}>DATOS DE COMUNICACIÓN</a>
                    </li>
                    <li id='nuevo-dato-admin' className={this.state.tab === 'nuevo-dato-admin' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='nuevo-dato-admin' className='nav-link' onClick={this.rederigir.bind(this)}>NUEVO DATO DE COMUNICACIÓN</a>
                    </li>
                </ul>
                {childs}
            </div>
        )
    }
}

export default DatosAdmin